export * from './IconDrillingPartLeftFilled';
